// // src/pages/CreateReturnBill.js
// import React from "react";
// import CreateBill from "../components/CreateBill.jsx";


// export default function CreateReturnBill() {
//   return <CreateBill type="return" />;
// }

import React from "react";
import CreateBill from "../Component/ReturnsBill";  // No need for .jsx

export default function CreateReturnBill() {
  return <CreateBill type="return" />;
}
